import React, { useContext, useEffect, useState } from "react";
import { API_URL } from "../../const";
import swal from "sweetalert";
import { ProductContext } from "../../Context/ProductContext";
import { Link } from "react-router-dom";

function ProductsManages() {
  const [products, setProducts] = useState([]);
  const { loading, setLoading } = useContext(ProductContext);

  const convertToDate = (timestamp) => {
    if (timestamp) {
      let a = new Date(timestamp);
      let year = a.getFullYear();
      let month = a.getMonth();
      let date = a.getDate();
      let time = date + "/" + month + "/" + year;
      return time;
    }

    return "01/01/2020";
  };

  const getProduct = () => {
    fetch(`${API_URL}/products`).then((res) =>
      res.json().then((data) => {
        setProducts(data);
        setLoading(false);
      })
    );
  };

  useEffect(() => {
    setLoading(true);
    getProduct();
  }, []);

  const deleteProduct = (id) => {
    swal({
      title: "Bạn có chắc là xóa hok",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const urlencoded = new URLSearchParams();

        const requestOptions = {
          method: "DELETE",
          body: urlencoded,
          redirect: "follow",
        };

        fetch(`${API_URL}/products/${id}`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (typeof result === "object") {
              swal({
                title: "Xóa thành công",
                icon: "success",
                button: "OK",
              });

              getProduct();
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        return null;
      }
    });
  };

  let body;

  if (loading) {
    body = (
      <div className="loading-admin">
        <div class="loader"></div>
      </div>
    );
  } else {
    body = (
      <table>
        <tr>
          <th>Id</th>
          <th>Name</th>
          <th>Image</th>
          <th>Created-at</th>
          <th>Action</th>
        </tr>
        {products.map((item, index) => (
          <tr>
            <td>{index + 1}</td>
            <td className="product-manages-name">
              <p>{item.name}</p>
            </td>
            <td style={{ textAlign: "center" }}>
              <p className="product-manages-img">
                <img src={item.image} alt={item.name} />
              </p>
            </td>
            <td>{convertToDate(item.createdAt)}</td>
            <td className="product-manages-action">
              <div className="product-manages-action-flex">
                <Link to={`/admin/products/edit/${item.id}`}>
                  <div className="review-edit">
                    <i class="fas fa-pen"></i>
                  </div>
                </Link>
                <div
                  className="review-delete"
                  onClick={() => deleteProduct(item.id)}
                >
                  <i class="fas fa-trash"></i>
                </div>
              </div>
            </td>
          </tr>
        ))}
      </table>
    );
  }

  return <div className="product-manages">{body}</div>;
}

export default ProductsManages;
